module.exports = __webpack_public_path__ + "static/media/polonium_network_event_placeholder_10.cdd1f299.png";